import { render, staticRenderFns } from "./StockRstats.vue?vue&type=template&id=1efd3250&scoped=true&"
import script from "./StockRstats.vue?vue&type=script&lang=js&"
export * from "./StockRstats.vue?vue&type=script&lang=js&"
import style0 from "./StockRstats.vue?vue&type=style&index=0&id=1efd3250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd3250",
  null
  
)

export default component.exports